import locale from "localization/en";
import styles from "../cash-noncash.module.scss";
import { Title } from "components/commons";
import useDataTable from "hooks/useDataTable";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { varianceAdjustmentMapper } from "./variance-adjustment.mapper";
import { varianceAdjustmentColumn } from "./variance-adjustment-column";
import { getPumpNumber } from "../../shift-details-utils";

const ShiftDetailsVarianceAdjustment = ({ shift }) => {
  const getAdjustedTransactions = () => {
    if (!shift?.transactionItem) return [];

    const adjusted = Object.entries(shift.transactionItem)
      .filter(([key]) => key.endsWith("Transactions"))
      .flatMap(([, value]) => (Array.isArray(value) ? value : []))
      .filter((item) => item?.transaction?.adjustmentType != null)
      .sort((a, b) => {
        const nameCompare = (a?.name || "").localeCompare(b?.name || "");
        if (nameCompare !== 0) return nameCompare;

        return getPumpNumber(a?.pump) - getPumpNumber(b?.pump);
      });
    return adjusted;
  };

  const adjustedTransactions = getAdjustedTransactions();
  const employee = shift?.shift.closedByEmail || "--";

  const { table } = useDataTable({
    value: adjustedTransactions,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (val) => val },
    table: {
      key: "transactionItems",
      name: "varianceAdjustment",
      mapper: (val) =>
        varianceAdjustmentMapper({ shiftDiscounts: shift?.shiftDiscounts, val, employee }),
      columns: varianceAdjustmentColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.varianceAdjustment}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsVarianceAdjustment;
